import React, { FC, useState, useEffect } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  FormHelperText,
  Grid,
  InputLabel,
  Tooltip,
} from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

const FormSelectField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState(props?.value || "");
  console.log("FormSelectField props:", props);
  const selectFontSize = props?.InputProps?.sx?.fontSize || "inherit";

  const formatVolumeUnitLabel = (label: string) => {
    if (label === "m3" || label === "m³" || label === "M3") return "m³";
    if (label === "ft3" || label === "ft³" || label === "FT3") return "ft³";
    return label;
  };
  useEffect(() => {
    if (props.value) {
      setValue(props.value);
    } else {
      setValue("");
    }
  }, [props.value]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    setValue(event.target.value);
    if (props.onChange) {
      props.onChange({
        target: {
          id: event?.target?.name,
          value: event?.target?.value,
        },
      });
    }
  };

  let boolVar = props?.options
    ? props?.options.some((value) => {
        return typeof value == "object";
      })
    : false;

  const selectRender = () => (
    <FormControl
      variant="outlined"
      style={{
        marginTop: props?.isNonMarginTop ? "0px" : "",
        width: props?.width ? props?.width : "",
        display: props?.display,
      }}
      fullWidth
      sx={{
        mt: 2,
        mb: 1,
        "& .MuiOutlinedInput-root": {
          border: props.error ? "none" : "1px solid #c4c4c4",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none", // Hides the legend visually
        },
        height: "36px",
        borderRadius: "5px",
        border: props.error ? "1px solid #d32f2f" : "none",
      }}
      error={Boolean(props.error)}
      size="small"
    >
      <Select
        disabled={props.disabled || false}
        sx={{ 
          background: "#fff", 
          height: "36px",
          "& .MuiSelect-select": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: selectFontSize,
          }
        }}
        displayEmpty
        value={value}
        onChange={handleChange}
        name={props.id}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
              "& .MuiMenuItem-root": {
                whiteSpace: "normal",
                wordWrap: "break-word",
                fontSize: selectFontSize,
              }
            }
          }
        }}
      >
        <MenuItem value="">
          {props?.placeHolder ? props?.placeHolder : "Select"}
        </MenuItem>
        {props.options &&
          props.options.map((option: any, index: number) => {
            const optionValue = boolVar ? option?.id : option;
            const rawOptionLabel =
              option?.name ||
              option?.label ||
              option?.type_name ||
              option?.role ||
              option;
            const optionLabel =
              props?.id === "volumeUnit" || props?.id === "volume_unit"
                ? formatVolumeUnitLabel(String(rawOptionLabel))
                : rawOptionLabel;

            return (
              <MenuItem
                key={index}
                value={optionValue}
                sx={{ 
                  textTransform: "capitalize",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  overflow: "hidden",
                }}
                title={option?.tooltip || optionLabel}
              >
                {optionLabel}
              </MenuItem>
            );
          })}
      </Select>
      {props.error && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  );

  return (
    <>
      {props.label && !props.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? (props?.firstColmd ? props?.firstColmd : 1.5) : 5}
            className={classes.labelBox}
            sx={{ marginTop: props?.isNonMarginTop ? "0px !important" : "" }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
                shrink
                htmlFor={props.id}
              >
                {props.label}
                {props.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{ padding: "0px" }}
          >
            {selectRender()}
          </Grid>
        </>
      ) : props.label && props.inSingleGridForm ? (
        <Grid
          item
          xs={12}
          sm={props?.md ? props?.md : 12}
          sx={{
            display: "block",
            alignItems: "center",
            gap: 2,
            ...props?.GridFieldStyle,
          }}
        >
          <Tooltip title={props?.tooltipText || ""} arrow>
            <InputLabel
              sx={{
                color: "#637381",
                fontWeight: 600,
                fontSize: "16px",
                textAlign: "left",
              }}
              shrink
              htmlFor={props.id}
            >
              {props.label}
              {props.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Tooltip>
          {selectRender()}
        </Grid>
      ) : (
        selectRender()
      )}
    </>
  );
};

export default FormSelectField;
